import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';
import moment from 'moment';
import { monthWithDays } from '../helper';
import { setCurrencyFormat } from '../../../utils/helpers';


const PromotionBar = ({ height, data, month1, selectedMonths }) => {
    const { month: fromCurrentMonth } = month1;

    const thisMonthData = {};

    data.forEach((item) => {
        selectedMonths.forEach((monthitem) => {
            const [month, year] = monthitem.split('-')
            if (item?.monthStr && item.monthStr === month) {
                const date = moment(`${item.monthStr}-${item?.day}-${item?.year}`, 'MMM-D-YYYY');
                const dateWithMonthYear = date.format('D-MMM-YYYY-DDD');
                if (item.day && thisMonthData[dateWithMonthYear]) {
                    thisMonthData[dateWithMonthYear].push(item)
                } else {
                    thisMonthData[dateWithMonthYear] = [item]
                }
            }
        })

    })
    const currentMonthDayCount = monthWithDays[fromCurrentMonth]

    const reduceCallback = (acc, item) => acc + Number(item.amount)
    const reduceCallbackForQty = (acc, item) => acc + Number(item.quantity)
    const dataToPlot = []

    Object.keys((thisMonthData)).forEach((dayMonthYear) => {
        const [day, month, year, dayofyear] = dayMonthYear.split('-');

        const currentMonthAmount = thisMonthData?.[dayMonthYear].reduce(reduceCallback, 0)
        const currentMonthDataKey = `${day}, ${month} ${year}`;

        dataToPlot.push({
            'Total Amount': currentMonthAmount,
            "day": `${currentMonthDataKey}`,
        })
    })

    return (
        <ResponsiveContainer width="100%" height={height}>
            <BarChart
                width={500}
                height={300}
                data={dataToPlot}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
                <XAxis dataKey="day" />
                <YAxis type="number" />
                <Tooltip formatter={value => setCurrencyFormat(Number(value).toFixed(2), true)} />
                <Legend />
                {/* <Bar dataKey={'Total Quantity'.toString()} fill="#82ca9d" /> */}
                <Bar dataKey={'Total Amount'.toString()} fill="#8884d8" />

            </BarChart>
        </ResponsiveContainer>
    )
}

PromotionBar.propTypes = {

    height: PropTypes.number.isRequired,
    data: PropTypes.arrayOf({}).isRequired,
    month1: PropTypes.objectOf({ key: '', value: '' }).isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    selectedMonths: PropTypes.array.isRequired,
};

export default React.memo(PromotionBar);